import { reqGet, reqPost, TStatusCallbak } from 'HttpRequests'
import { IOrder } from './IOrder'

function reqGetActiveOrders(callback: (bids: IOrder[]) => void) {
  reqGet('api/get_active_orders/', callback)
}
function reqGetAllOrders(callback: (bids: IOrder[]) => void) {
  reqGet('api/get_all_orders/', callback)
}

function reqCancelOrder(orderId: number, callback: TStatusCallbak) {
  reqPost('api/cancel_order/', { orderId }, callback)
}

export { reqGetActiveOrders, reqGetAllOrders, reqCancelOrder }
